import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import NewButton from 'ui/atoms/NewButton/NewButton'
import InfoBanner from 'ui/components/InfoBanner/InfoBanner'
import Tooltip from 'ui/components/Tooltip/Tooltip'
import styles from './ModalButtons.module.less'

type ModalButtonsProps = {
  cancelLabel?: string
  submitLabel?: string
  submitVariant?: 'primary' | 'success'
  infoText?: string
  icon?: string
  disableSubmit?: boolean
  disableDelete?: boolean
  submitDisabledText?: string
  onSubmit?: () => void
  onCancel?: () => void
  onDelete?: () => void
  isSubmitting?: boolean
}
// This Modalbutton uses the NewButton component to render buttons in modals throughout the app.
export default function NewModalButtons({
  onSubmit,
  onCancel,
  onDelete,
  cancelLabel,
  submitLabel,
  submitVariant,
  infoText,
  disableSubmit,
  disableDelete,
  submitDisabledText,
  icon,
  isSubmitting,
}: ModalButtonsProps): ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <div className={styles.ModalButtons_InfoBanner}>
        {onDelete && (
          <div className={styles.ModalButtons_Buttons_LeftButtons}>
            <div className={styles.ModalButtons_Buttons_LeftButtons__delete}>
              <NewButton
                variant="delete"
                disabled={disableDelete}
                onClick={() => {
                  if (onDelete) {
                    onDelete()
                  }
                }}
              />
            </div>
          </div>
        )}

        {infoText && <InfoBanner style="warning" text={infoText} />}
      </div>
      <div>
        <div className={styles.ModalButtons_Buttons}>
          <div className={styles.ModalButtons_Buttons_RightButtons__cancel}>
            <NewButton
              variant="outlined"
              label={cancelLabel ?? t('Cancel')}
              onClick={() => {
                if (onCancel) {
                  onCancel()
                }
              }}
            />
          </div>
          <div className={styles.ModalButtons_Buttons_RightButtons__submit}>
            <Tooltip title={submitDisabledText ? submitDisabledText : ''} placement="top-end" display="block" arrow>
              <span>
                <NewButton
                  variant={submitVariant ?? 'primary'}
                  label={submitLabel ?? t('Save')}
                  icon={icon}
                  disabled={disableSubmit ?? false}
                  loading={isSubmitting}
                  onClick={() => {
                    if (onSubmit && !isSubmitting) {
                      onSubmit()
                    }
                  }}
                />
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  )
}
